import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import styles from "../style/Navbar.module.css";
import { FaPhoneAlt, FaBars, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

// const menuItems = ["Home", "About", "Services", "Portfolio", "Career", "Contact"];

const menuItems = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Careers", path: "/careers" },
  { name: "Blog", path: "/blogs" },
  // { name: "Team", path: "/Team" },
  { name: "Contact", path: "/contact" },
  { name: "Portfolio", path: "/portfolio" },
];


const Navbar = () => {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate()

  // const {navigate} = useNavigate()

  return (
    <motion.nav
      className={styles.navbar}
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* Logo */}
      <div onClick={() => navigate("/")} style={{ cursor: 'pointer' }} className={styles.logo}>
        <img src="/assets/logo1.png" width="180" alt="CreaTech Squads - SEO and Digital Marketing India" fetchpriority="high" loading="eager" />
      </div>

      {/* Desktop Menu */}
      <ul className={styles.menu}>
        {menuItems?.map((item, index) => (
          <motion.li
            key={index}
            whileHover={{ scale: 1.1, color: "#00ff99" }}
            transition={{ type: "spring", stiffness: 300 }}
            onClick={() => navigate(item?.path)}
          >
            {item?.name}
          </motion.li>
        ))}
      </ul>

      {/* Button */}
      <motion.button
        className={styles.callBtn}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => (window.location.href = "tel:+919278139919")}
      >
        <FaPhoneAlt /> +91 9278139919
      </motion.button>

      {/* Mobile Icon */}
      <div className={styles.hamburger} onClick={() => setOpen(!open)}>
        {open ? <FaTimes /> : <FaBars />}
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {open && (
          <motion.div
            className={styles.mobileMenu}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            {menuItems?.map((item, index) => (
              <div key={index} className={styles.mobileItem} onClick={() => { navigate(item?.path); setOpen(false); }}>
                {item?.name}
              </div>
            ))}

            <button
              className={styles.mobileBtn}
              onClick={() => (window.location.href = "tel:+919278139919")}
            >
              <FaPhoneAlt /> +91 9278139919
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;
